/**
 * Manifest du shell — les raccourcis qui n'appartiennent à aucune feature.
 *
 * @remarks
 * Le shell n'est pas une feature, mais ses raccourcis passent par le même
 * contrat (`manifest.shortcuts`) : ils sont écoutés par `useFeatureShortcuts`
 * et listés dans l'écran Paramètres comme les autres, sans liste tenue à part.
 *
 * `contexts` est vide : ce manifest ne rend rien, il ne fait que déclarer.
 */

import { commandBus } from '@/app/commands/command-bus';
import type { FeatureManifest } from '@/app/registry';

export const shellManifest: FeatureManifest = {
  id: 'shell',
  contexts: [],

  shortcuts: [
    {
      id: 'shell:toggle-left-panel',
      // Pas `mod+b` : Firefox l'associe aux marque-pages, et l'éditeur de
      // document au gras. Même logique que VS Code pour son panneau secondaire.
      keys: 'mod+alt+b',
      label: 'Afficher ou masquer le panneau gauche',
      scope: 'global',
      // Sous Windows, Ctrl+Alt équivaut à AltGr, qui sert à taper des caractères
      // selon la disposition du clavier : on laisse la touche au champ de saisie.
      ignoreInEditable: true,
      // Le shell actif décide de l'effet : panneaux du desktop ou tiroir de la
      // tablette, qui ne lit pas le layout store.
      handler: () => {
        commandBus.emit('shell:toggle-panel', 'left');
      },
    },
    {
      id: 'shell:toggle-right-panel',
      keys: 'mod+alt+shift+b',
      label: 'Afficher ou masquer le panneau droit',
      scope: 'global',
      ignoreInEditable: true,
      handler: () => {
        commandBus.emit('shell:toggle-panel', 'right');
      },
    },
    {
      id: 'shell:toggle-command-palette',
      keys: 'mod+k',
      label: 'Ouvrir la palette de commandes',
      scope: 'global',
      // L'état d'ouverture vit dans `CommandBar`, qui écoute cette commande.
      handler: () => {
        commandBus.emit('shell:toggle-command-palette');
      },
    },
  ],
};
